<script>
  import dayjs from 'dayjs';
  import Flatpickr from 'svelte-flatpickr';
  import 'flatpickr/dist/flatpickr.css';
  import 'flatpickr/dist/themes/airbnb.css';
  import { createEventDispatcher } from 'svelte';
  import { getLastXDays, dateFormat } from '../utils.js';

  let date;
  let selected;
  let active = 7;
  let customSelected = false;
  let dialogClosed = true;
  let dialogRef;
  let output = {
    startDate: null,
    endDate: null,
  };
  const flatpickrOptions = {
    element: '#my-picker',
    mode: 'range',
    maxDate: 'today',
    dateFormat: 'Y-m-d',
    inline: true,
    onChange(selectedDates) {
      output.startDate = dayjs(selectedDates[0]).format(dateFormat);
      output.endDate = selectedDates[1] ? dayjs(selectedDates[1]).format(dateFormat) : null;
    },
  };
  const dispatch = createEventDispatcher();
  const customDates = () => {
    dialogClosed = !dialogClosed;
    active = null;
    if (output.startDate && output.endDate) {
      saveDates();
      selected = 'custom-dates';
      dialogRef.close();
    }
  };
  const lastXDays = (x) => {
    active = x;
    customSelected = false;
    dialogClosed = true;
    output = getLastXDays(x, dateFormat);
    resetCustom();
    saveDates();
    clearCustomRange();
  };
  const clearCustomRange = () => {
    output.endDate = null;
    output.startDate = null;
  };
  const resetCustom = () => {
    date = null;
  };
  const saveDates = () => {
    dispatch('dateSelected', output);
  };
  const closeDialog = () => {
    dialogClosed = !dialogClosed;
    customSelected = false;
    clearCustomRange();
    selected = 'default';
    dialogRef.close();
  };
</script>

<select
  class="mobile-only"
  bind:value={selected}
  on:change={() => {
    if (selected == 'custom') {
      dialogClosed = !dialogClosed;
      dialogRef.showModal();
    } else {
      lastXDays(selected);
    }
  }}
>
  <option disabled value="default">Select Date</option>
  <option value="7">7 days</option>
  <option value="15">15 days</option>
  <option value="30">30 days</option>
  <option value="custom">{selected == 'custom-dates' ? 'New Custom Range' : 'Custom Range'}</option>
  {#if ![7, 15, 30, 'custom', 'default'].includes(selected) && output.endDate != null && output.startDate != null}
    <option value="custom-dates">{`${output.startDate} - ${output.endDate}`}</option>
  {/if}
</select>

<div class="desktop-only">
  <button class="secondary light" class:active={active == 7} on:click={() => lastXDays(7)}>7 days</button>
  <button class="secondary light" class:active={active == 15} on:click={() => lastXDays(15)}>15 days</button>
  <button class="secondary light" class:active={active == 30} on:click={() => lastXDays(30)}>30 days</button>
  <button
    class="secondary light"
    class:active={customSelected}
    on:click={() => {
      dialogClosed = !dialogClosed;
      customSelected = true;
      dialogRef.showModal();
    }}
    >{customSelected && output.startDate != null && output.endDate != null
      ? `${output.startDate} - ${output.endDate}`
      : 'Custom Range'}</button
  >
</div>

<dialog bind:this={dialogRef} class:closed={dialogClosed}>
  <Flatpickr options={flatpickrOptions} element="#my-picker" bind:value={date}>
    <div id="my-date-picker">
      <div class="flatpickr" id="my-picker">
        <h2 style="color: #05126d; font-size: 1.5rem; margin-bottom: 0.5em">Select custom range</h2>
        <input style="display:none" type="text" placeholder="Select custom dates.." data-input />
      </div>
    </div>
  </Flatpickr>
  <div class="dialog-buttons">
    <button on:click={closeDialog} class="secondary">Close</button>
    <button on:click={customDates} class="primary">Filter Dates</button>
  </div>
</dialog>

<style>.mobile-only{display:none}.light{color:var(--t-c-l)}.active{color:var(--h-c)}dialog{background-color:#fff;border:1px solid #dadada;border-radius:5px;left:50%;margin:0 auto;padding:1em;position:fixed;right:unset;top:0;transform:translate(-50%,50%)}dialog::-webkit-backdrop{background:rgba(2,6,36,.6)}dialog::backdrop{background:rgba(2,6,36,.6)}.dialog-buttons>button{margin-top:.5em}.dialog-buttons{display:flex;justify-content:space-between}dialog.closed{display:none}:global(.flatpickr-day.selected,.flatpickr-day.startRange,.flatpickr-day.endRange,.flatpickr-day.selected.inRange,.flatpickr-day.startRange.inRange,.flatpickr-day.endRange.inRange,.flatpickr-day.selected:focus,.flatpickr-day.startRange:focus,.flatpickr-day.endRange:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange:hover,.flatpickr-day.endRange:hover,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.endRange.nextMonthDay){background-color:var(--s-c)!important;border-color:var(--s-c)!important}:global(.flatpickr-calendar *,.flatpickr-calendar,span.flatpickr-day,span.flatpickr-day.prevMonthDay,span.flatpickr-day.nextMonthDay){border:none!important;box-shadow:none!important}@media (max-width:740px){dialog{transform:translate(-50%,25%)}.desktop-only{display:none}.mobile-only{display:block}}</style>
